import Vue from 'vue'
import moment from 'moment'

export default {
  convert (date, format) {
    switch (Vue.i18n.locale()) {
      case 'br':
        switch (format) {
          case 'date':
            return moment(date).format('DD/MM/YYYY')
          case 'datetime':
            return moment(date).format('DD/MM/YYYY HH:mm:ss')
          case 'datetime-min':
            return moment(date).format('DD/MM/YYYY HH:mm')
          default:
            return date
        }
      default:
        return date
    }
  },
}



// WEBPACK FOOTER //
// ./src/services/time.js